import { render, staticRenderFns } from "./BillingManagement.vue?vue&type=template&id=f481b4d4&scoped=true"
import script from "./BillingManagement.vue?vue&type=script&lang=js"
export * from "./BillingManagement.vue?vue&type=script&lang=js"
import style0 from "./BillingManagement.vue?vue&type=style&index=0&id=f481b4d4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f481b4d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f481b4d4')) {
      api.createRecord('f481b4d4', component.options)
    } else {
      api.reload('f481b4d4', component.options)
    }
    module.hot.accept("./BillingManagement.vue?vue&type=template&id=f481b4d4&scoped=true", function () {
      api.rerender('f481b4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingAdjustmentManagement/BillingManagement.vue"
export default component.exports